"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = require("swiper");
var flatpickr_1 = require("flatpickr");
var ja_js_1 = require("flatpickr/dist/l10n/ja.js");
require("bootstrap/js/dist/util");
require("bootstrap/js/dist/collapse");
var smoothScroll = function () {
    var anchorLinks = document.querySelectorAll('a[href^="#"]');
    var convertArray = Array.from(anchorLinks);
    var _loop_1 = function (anchorLink) {
        anchorLink.addEventListener('click', function (e) {
            var _a, _b;
            e.preventDefault();
            var targetId = anchorLink.getAttribute('href');
            var targetElement = document.querySelector(targetId);
            if (targetElement != null) {
                var headerHeight = (_b = (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0;
                var offset = targetElement.offsetTop - headerHeight;
                console.log(offset);
                window.scrollTo({ top: offset, behavior: 'smooth' });
            }
        });
    };
    for (var _i = 0, convertArray_1 = convertArray; _i < convertArray_1.length; _i++) {
        var anchorLink = convertArray_1[_i];
        _loop_1(anchorLink);
    }
};
// ハンバーガーメニュー
var humMenu = function () {
    var menu = document.querySelector('#menu');
    var menuBtn = document.getElementById('menu-btn');
    if (menu !== null && menuBtn !== null) {
        menuBtn.addEventListener('click', function () {
            if (menuBtn.classList.contains('active')) {
                menuBtn.classList.remove('active');
                menu.classList.remove('active');
            }
            else {
                menuBtn.classList.add('active');
                menu.classList.add('active');
            }
        });
    }
};
// TOPスライダー
var topSlider = function () {
    var swiper = new swiper_1.default('.top-slider', {
        modules: [swiper_1.Autoplay, swiper_1.EffectFade],
        loop: true,
        speed: 5000,
        effect: 'fade',
        slidesPerView: 'auto',
        allowTouchMove: false,
        autoplay: {
            delay: 1000,
        },
    });
    // swiper.init()
};
// 予約カレンダーの日付更新
var reserveCalendar = function () {
    // 宿泊数を計算し、#leのvalueに設定する関数
    var updateNights = function () {
        var checkinDate = document.querySelector('#js-datepicker-checkin').value;
        var checkoutDate = document.querySelector('#js-datepicker-checkout').value;
        var nightsInput = document.querySelector('#le');
        if (checkinDate.length > 0 && checkoutDate.length > 0) {
            var checkin = new Date(checkinDate);
            var checkout = new Date(checkoutDate);
            var nights = (checkout.getTime() - checkin.getTime()) / (1000 * 60 * 60 * 24); // ミリ秒から日に変換
            if (nights > 0) {
                nightsInput.value = nights.toString(); // 宿泊数をhidden inputにセット
            }
            else {
                nightsInput.value = '';
            }
        }
    };
    // flatpickrのインスタンス型を定義
    var checkinPicker = (0, flatpickr_1.default)('#js-datepicker-checkin', {
        locale: ja_js_1.Japanese,
        dateFormat: 'Y/m/d',
        defaultDate: new Date(new Date().setDate(new Date().getDate() + 1)),
        minDate: new Date(),
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 2)),
        onChange: function (selectedDates) {
            if (selectedDates.length > 0) {
                var nextDay = new Date(selectedDates[0]);
                nextDay.setDate(nextDay.getDate() + 1);
                // 現在のチェックアウト日を取得
                var currentCheckout = checkoutPicker.selectedDates[0];
                // チェックアウトの最小日付を更新
                checkoutPicker.set('minDate', nextDay);
                // チェックアウト日が未選択、もしくはチェックイン日以前の場合のみ、チェックアウト日を更新
                if (currentCheckout === undefined ||
                    currentCheckout <= selectedDates[0]) {
                    checkoutPicker.setDate(nextDay);
                }
                updateNights();
            }
        },
    });
    var checkoutPicker = (0, flatpickr_1.default)('#js-datepicker-checkout', {
        locale: ja_js_1.Japanese,
        dateFormat: 'Y/m/d',
        defaultDate: new Date(new Date().setDate(new Date().getDate() + 2)),
        minDate: new Date(new Date().setDate(new Date().getDate() + 2)),
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 2)),
        onChange: updateNights,
    });
};
// OneHarmonyバナーがスクロールでfooterエリアに入ると消える
var scrollInvisibleBnr = function () {
    var bnr = document.querySelector('.scrollInvisible');
    var scrollTopBtn = document.querySelector('.scrollTop');
    if (bnr != null && scrollTopBtn != null) {
        var bnrHeight = bnr.offsetHeight; // バナーの高さを取得
        var btnTop = scrollTopBtn.getBoundingClientRect().top + window.scrollY; // scrollTop要素の上部位置を取得
        window.addEventListener('scroll', function () {
            var scrollPosition = window.scrollY; // 現在のスクロール位置
            // バナーの下端がscrollTop要素の上端を超えたら
            // if (scrollPosition + window.innerHeight - bnrHeight >= btnTop) {
            //   bnr.style.position = 'absolute'
            //   bnr.style.top = `${btnTop - bnrHeight}px` // ピタッと止まる位置を設定
            // } else {
            bnr.style.position = 'fixed';
            bnr.style.bottom = '12%';
            bnr.style.top = 'auto'; // リセット
            // }
        });
    }
};
var closeFixedBnr = function () {
    var bnr = document.querySelector('.scrollInvisible');
    if (bnr === null)
        return;
    var close = bnr.querySelector('.bnr-close');
    if (close === null)
        return;
    close.addEventListener('click', function () {
        bnr.style.display = 'none';
    });
};
// 100vhスクロールしたらscrollFooterSpMenuにvisibleクラスを追加
var scrollFooterSpMenu = function () {
    var footerSpMenu = document.querySelector('.scrollFooterSpMenu');
    if (footerSpMenu != null) {
        window.addEventListener('scroll', function () {
            var scrollPosition = window.scrollY; // 現在のスクロール位置
            if (scrollPosition > 100) {
                footerSpMenu.classList.add('visible');
            }
            else {
                footerSpMenu.classList.remove('visible');
            }
        });
    }
};
// 部屋タイプ画像スライダー
var roomSlider = function () {
    var swiperElements = document.querySelectorAll("[class*=\"room-slider-\"]");
    var elementsArray = Array.from(swiperElements);
    for (var _i = 0, elementsArray_1 = elementsArray; _i < elementsArray_1.length; _i++) {
        var swiperElement = elementsArray_1[_i];
        var classSelector = ".".concat(Array.from(swiperElement.classList).join('.'));
        var swiper = new swiper_1.default(classSelector, {
            modules: [swiper_1.Autoplay, swiper_1.Pagination],
            loop: true,
            speed: 3000,
            slidesPerView: 'auto',
            autoplay: {
                delay: 1000,
            },
            pagination: {
                el: '.room-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
        // swiper.init()
    }
};
// レストラン画像スライダー
var restaurantSlider = function () {
    var swiperElements = document.querySelectorAll("[class*=\"restaurant-slider-\"]");
    var elementsArray = Array.from(swiperElements);
    for (var _i = 0, elementsArray_2 = elementsArray; _i < elementsArray_2.length; _i++) {
        var swiperElement = elementsArray_2[_i];
        var classSelector = ".".concat(Array.from(swiperElement.classList).join('.'));
        var swiper = new swiper_1.default(classSelector, {
            modules: [swiper_1.Autoplay, swiper_1.Pagination],
            loop: true,
            speed: 3000,
            slidesPerView: 'auto',
            autoplay: {
                delay: 1000,
            },
            pagination: {
                el: '.restaurant-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
        // swiper.init()
    }
};
// top レストラン スライダー
var topRestaurantSlider = function () {
    var swiper = new swiper_1.default('.breakfast-slider', {
        modules: [swiper_1.Autoplay, swiper_1.Pagination],
        loop: true,
        speed: 3000,
        spaceBetween: 20,
        slidesPerView: 'auto',
        autoplay: {
            delay: 1000,
        },
        pagination: {
            el: '.restaurant-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
};
// レストランサムネイル付きスライダー
var initializeSlider = function () {
    var mainSliders = document.querySelectorAll('.jalcity-slider-main');
    var thumbSliders = document.querySelectorAll('.jalcity-slider-thumbnail');
    var nextButtons = document.querySelectorAll('.jalcity-slider-next');
    var prevButtons = document.querySelectorAll('.jalcity-slider-prev');
    for (var i = 0; i < mainSliders.length; i++) {
        var mainSlider = mainSliders[i];
        var thumbSlider = thumbSliders[i];
        var nextEl = nextButtons[i];
        var prevEl = prevButtons[i];
        if (mainSlider === null ||
            thumbSlider === null ||
            nextEl === null ||
            prevEl === null) {
            continue;
        }
        var swiperThumb = new swiper_1.default(thumbSlider, {
            modules: [swiper_1.Navigation],
            loop: true,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            centeredSlides: true,
            slidesPerView: 5.8,
            spaceBetween: 20,
        });
        var mainSwiper = new swiper_1.default(mainSlider, {
            modules: [swiper_1.Autoplay, swiper_1.Thumbs, swiper_1.EffectFade],
            slidesPerView: 1,
            effect: 'fade',
            loop: true,
            autoplay: {
                delay: 3000,
            },
            thumbs: {
                swiper: swiperThumb,
            },
        });
        mainSwiper.init();
    }
};
var selectLangage = function () {
    var langageTrigger = document.getElementById('select-language');
    var langageList = document.getElementById('select-language-list');
    if (langageTrigger === null || langageList === null) {
        return;
    }
    langageTrigger.addEventListener('click', function () {
        langageList.classList.toggle('visible');
    });
};
document.addEventListener('DOMContentLoaded', function () {
    humMenu();
    topSlider();
    reserveCalendar();
    scrollInvisibleBnr();
    scrollFooterSpMenu();
    roomSlider();
    restaurantSlider();
    initializeSlider();
    smoothScroll();
    topRestaurantSlider();
    selectLangage();
    closeFixedBnr();
});
